import { Row, Col } from 'react-bootstrap';
import SimpleCard from 'components/global/SimpleCard';
import { formatMoneyNoDecimals } from 'utils/formatMoney';
import { $detail } from 'signals/global.signals';
import moment from 'moment';

const PublicRoomHighlightsAcquisition = () => (
  <SimpleCard className="bg-dark text-light p-16">
    <h6 className="fw-600 m-0 text-muted pb-16">Room Name: {$detail.value.name}</h6>
    <Row className="mb-32">
      <Col>
        <h4 className="fw-600 text-gradient-info-white">{formatMoneyNoDecimals($detail.value.deal?.preMoneyValuation)}</h4>
        <div><small>Purchase Price</small></div>
      </Col>
      <Col>
        <h4 className="fw-600 text-gradient-primary-white">{moment($detail.value.fundingDate).format('MM/DD/YYYY')}</h4>
        <div><small>Closing Date</small></div>
      </Col>
    </Row>
  </SimpleCard>
);

export default PublicRoomHighlightsAcquisition;
